import { useLayoutEffect } from 'react';

// The inline-support bar renders position:fixed (outside normal flow) in early-shell mode.
// #static-early-shell's own box (which owns the scrollable card content) must end above it —
// padding alone isn't enough, since content that doesn't need scrolling never reaches padding
// added at the bottom, and would otherwise sit right where the fixed bar overlaps it.
export const useReserveTailSpace = (active, shellElId, tailRef) => {
  useLayoutEffect(() => {
    if (!active) return undefined;
    const shellEl = document.getElementById(shellElId);
    const tailEl = tailRef.current;
    if (!shellEl || !tailEl) return undefined;
    const observer = new ResizeObserver(() => {
      // top + height + bottom would be over-constrained (CSS drops `bottom`), so clear
      // the shell's own height:100vh and let top/bottom define it instead.
      shellEl.style.height = 'auto';
      shellEl.style.bottom = `${tailEl.offsetHeight}px`;
    });
    observer.observe(tailEl);
    return () => observer.disconnect();
  }, [active, shellElId, tailRef]);
};
